// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../node_modules/_autoprefixer-loader@3.2.0@autoprefixer-loader/index.js!../../node_modules/_less-loader@2.2.3@less-loader/index.js!./style.less");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../node_modules/_style-loader@0.13.2@style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../node_modules/_autoprefixer-loader@3.2.0@autoprefixer-loader/index.js!../../node_modules/_less-loader@2.2.3@less-loader/index.js!./style.less", function() {
			var newContent = require("!!../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../node_modules/_autoprefixer-loader@3.2.0@autoprefixer-loader/index.js!../../node_modules/_less-loader@2.2.3@less-loader/index.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./src/less/style.less
// module id = 54
// module chunks = 0